import {MAIN_CONTACTS, MAIN_CONTACTS_CHEERS} from 'modules/footer/components/Footer/constants';
import {ICity} from 'modules/locations/models';
import {cityIn} from 'lvovich';
import {IStock} from 'modules/stock-x/types';

export const metaData = {
    about: {
        title: 'О магазине',
    },
    app: {
        title: 'Мобильное приложение',
    },
    articles: {
        title: 'Интересно о вине',
    },
    brands: {
        title: 'Бренды',
    },
    cart: {
        title: 'Корзина — SimpleWine',
    },
    cookiesPolicy: {
        title: 'Политика cookies',
    },
    events: {
        description: (cityTitle: ICity['title'] = 'Москва') =>
            `SimpleWine: расписание дегустаций, курсов и мастер-классов в ${cityIn(
                cityTitle,
            )}, винная дегустация в подарок`,
        title: (cityTitle: ICity['title'] = 'Москва') =>
            `Мероприятия с дегустацией в ${cityIn(
                cityTitle,
            )} в ${new Date().getFullYear()} году: расписание и стоимость, винная дегустация в подарок | SimpleWine`,
    },
    home: {
        description:
            '✔Интернет витрина магазина Simplewine: купить алкоголь по выгодным ценам. ✔Консультации специалистов при выборе. ✔Онлайн-бронирование и выдача в винотеках.',
        title: 'Интернет-витрина магазина SimpleWine: продажа хорошего алкоголя в Москве и Санкт-Петербурге, цены на сайте',
    },
    loyalty: {
        title: 'Программа лояльности',
    },
    personal: {
        title: 'Личный кабинет',
    },
    personalDataProcessing: {
        title: 'Политика обработки персональных данных',
    },
    privacyPolicy: {
        title: 'Согласие на обработку персональных данных',
    },
    recommendationTechnologies: {
        title: 'Правила применения рекомендательных технологий',
    },
    programRules: {
        title: 'Правила программы лояльности SimpleWine',
    },
    stock: {
        title: 'Акции',
        discount: {
            title: 'Акции и скидки на вино и алкоголь в SimpleWine',
            description: 'Актуальные акции и скидки на вино и алкоголь в SimpleWine',
        },
        detail: {
            title: (title: IStock['title']) => `${title} | Акции и скидки на алкоголь в SimpleWine`,
            description: (description?: IStock['description']) =>
                description
                    ? `${description}`
                    : `На странице представлены все актуальные акции и скидки на товары SimpleWine`,
        },
    },
    terms: {
        title: 'Условия продажи',
    },
    wineshops: {
        description: 'Винотеки SimpleWine на карте, список адресов и телефонов, описания, фото.',
        title: 'Винотеки SimpleWine в Москве, Санкт-Петербурге и Ростове-на-Дону: адреса магазинов и баров',
    },
    search: {
        title: 'Поиск по сайту simplewine.ru',
    },
};

export const ORG_JSON_LD = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '@context': 'https://schema.org',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '@type': 'Organization',
    name: 'SimpleWine',
    url: 'https://simplewine.ru',
    logo: 'https://simplewine.ru/static/local/assets/logo/logo-new--mobile.svg',
    image: 'https://simplewine.ru/static/local/assets/logo/logo-new--mobile.svg',
    description: metaData.home.description,
    telephone: MAIN_CONTACTS[0].text,
    email: MAIN_CONTACTS_CHEERS.text,
    sameAs: ['https://vk.com/simplewine', 'https://www.youtube.com/user/wineisSimple'],
    address: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '@type': 'PostalAddress',
        streetAddress: 'ул. Степана Супруна, дом 3–5, строение 1',
        addressLocality: 'Москва',
        postalCode: '125167',
        addressCountry: 'RU',
    },
};
